import { render, staticRenderFns } from "./categoryTablegroup.vue?vue&type=template&id=2ebeaf1c&scoped=true"
import script from "./categoryTablegroup.vue?vue&type=script&lang=js"
export * from "./categoryTablegroup.vue?vue&type=script&lang=js"
import style0 from "./categoryTablegroup.vue?vue&type=style&index=0&id=2ebeaf1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebeaf1c",
  null
  
)

export default component.exports